import React, { useCallback, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { experienceService } from '@/services/experience.service';
import { PublicLayout } from '@/components/public/PublicLayout';
import { Seo } from '@/components/Seo';
import { ExperienceStorefrontView } from '@/components/public/ExperienceStorefrontView';
import { OwnerEventsSection } from '@/components/public/OwnerEventsSection';
import { CetsTrees } from '@/components/CetsTrees';
import { StorefrontBanner } from '@/components/StorefrontBanner';
import { Skeleton } from '@/components/ui/skeleton';
import { Button } from '@/components/ui/button';
import { ChevronRight, Sparkles } from 'lucide-react';

export default function ExperienceStorefrontPublic() {
  const { ownerId } = useParams();
  const [data, setData] = useState(null);
  const [state, setState] = useState('loading'); // loading | ok | notfound

  const load = useCallback(async () => {
    setState('loading');
    try {
      setData(await experienceService.publicStorefront(ownerId));
      setState('ok');
    } catch {
      setState('notfound');
    }
  }, [ownerId]);
  useEffect(() => { load(); }, [load]);

  return (
    <PublicLayout>
      <StorefrontBanner ownerId={ownerId} />
      <Seo
        title={data ? `${data.name} — Esperienze in Sila` : 'Organizzatore — Sila Experiences'}
        description={data?.tagline || 'Scopri le esperienze proposte da questo organizzatore in Sila.'}
      />
      <div className="sila-section py-8">
        <nav className="mb-4 flex items-center gap-1 text-sm text-muted-foreground" aria-label="Percorso">
          <Link to="/" className="transition-colors hover:text-foreground">Home</Link>
          <ChevronRight className="h-4 w-4" />
          <Link to="/esperienze/catalogo" className="transition-colors hover:text-foreground">Esperienze</Link>
          <ChevronRight className="h-4 w-4" />
          <span className="text-foreground">{data?.name || 'Organizzatore'}</span>
        </nav>

        {state === 'ok' && data && (
          <div className="mb-5"><CetsTrees ownerId={ownerId} size="md" data-testid="cets-vetrina-badge" /></div>
        )}

        {state === 'loading' && (
          <div className="space-y-4">
            <Skeleton className="h-[42vh] w-full rounded-3xl" />
            <Skeleton className="h-40 w-full rounded-2xl" />
          </div>
        )}

        {state === 'notfound' && (
          <div className="rounded-2xl border border-border bg-card p-10 text-center" data-testid="storefront-notfound">
            <Sparkles className="mx-auto h-10 w-10 text-muted-foreground" />
            <h1 className="mt-3 font-display text-2xl font-bold">Vetrina non disponibile</h1>
            <p className="mt-1 text-muted-foreground">La pagina che cerchi non esiste o non è ancora pubblicata.</p>
            <Button asChild className="mt-4"><Link to="/esperienze/catalogo">Vai al catalogo</Link></Button>
          </div>
        )}

        {state === 'ok' && data && <ExperienceStorefrontView data={data} publicMode />}
        {state === 'ok' && data && <OwnerEventsSection ownerId={ownerId} />}
      </div>
    </PublicLayout>
  );
}
